/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import Overlay from "./Overlay";

export default Overlay;
